import React, { useState, useEffect } from "react";
import { Cookie } from "lucide-react";

const STORAGE_KEY = "compliche-cookie-consent-v1";
const SIMPLE_KEY = "compliche_cookies"; // read by index.js to gate PostHog init

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      const t = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = (kind) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ kind, ts: Date.now() }));
    // Backwards-compatible flag used by analytics gating in index.js
    localStorage.setItem(SIMPLE_KEY, kind === "all" ? "accepted" : "essential");
    setVisible(false);
    // Lazy-init PostHog right now if the user opted in (otherwise it's already a no-op).
    if (kind === "all" && process.env.REACT_APP_POSTHOG_KEY && !window.__compliche_posthog) {
      import("posthog-js").then(({ default: posthog }) => {
        posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
          api_host: process.env.REACT_APP_POSTHOG_HOST || "https://eu.i.posthog.com",
          persistence: "localStorage",
          autocapture: true,
        });
        window.__compliche_posthog = posthog;
      }).catch(() => {});
    }
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-4 inset-x-4 md:inset-x-auto md:right-6 md:bottom-6 md:max-w-md z-50 animate-slide-up"
      data-testid="cookie-consent"
    >
      <div className="card2 p-5 shadow-card-hover">
        <div className="flex items-start gap-3">
          <Cookie size={20} className="text-indigo2 mt-1 flex-shrink-0" />
          <div className="flex-1">
            <div className="t-h4 mb-1">Your privacy matters</div>
            <p className="t-body-sm text-slate2">
              We use essential cookies for sign-in and security. With consent we also use analytics to improve Compliche. You can change this anytime.
            </p>
            <div className="mt-4 flex gap-2">
              <button className="btn btn-primary btn-sm flex-1" onClick={() => accept("all")} data-testid="cookie-accept-all">Accept all</button>
              <button className="btn btn-ghost btn-sm flex-1" onClick={() => accept("essential")} data-testid="cookie-essential-only">Essential only</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
